var _circle, _ellipse, _ellipse2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    "aria-labelledby": titleId,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "avatarTitle"
  }, "Avatar Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "avatarTitle"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 9,
    fill: "white",
    stroke: "#C9C9CB",
    strokeWidth: 0.888889
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.01038,
    cy: 15.8857,
    rx: 6.75,
    ry: 3.61362,
    fill: "#C9C9CB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.11591,
    cy: 7.67616,
    rx: 3.13043,
    ry: 3.52174,
    fill: "#C9C9CB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 9,
    stroke: "#C9C9CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.c4f20301f41644f3cbb904c8e5fe7487.svg";
export { ForwardRef as ReactComponent };